import React, { useState } from "react";
import { useSelector } from "react-redux";
import SvgMap from "../../components/Map/Map";
import Composition from "../../components/Composition/Composition";
import MineralsLegend from "../../components/MineralsLegend/MineralsLegend";
import Filters from "../../components/Filters/Filters";
import WasteGroups from "../../components/WasteGroups/WasteGroups";
import RegionsInfo from "../../components/RegionsInfo/RegionsInfo";
import Co2Slider from "../../components/Co2Slider/Co2Slider";
import "./MapPage.css";

const MapPage = () => {
    const [showLeftPanel, setShowLeftPanel] = useState(window.innerWidth > 768);
    const [showRightPanel, setShowRightPanel] = useState(
        window.innerWidth > 768
    );
    const points = useSelector((state) => state.points.points);

    return (
        <div className="app">
            <div className="central-components">
                <Co2Slider />
            </div>
            <div className="main-layout">
                <div className="top-section">
                    {!showRightPanel && (
                        <button
                            className="left-toggle-button"
                            onClick={() => setShowLeftPanel(!showLeftPanel)}
                        >
                            {showLeftPanel ? "←" : "→"}
                        </button>
                    )}

                    {!showLeftPanel && (
                        <button
                            className="right-toggle-button"
                            onClick={() => setShowRightPanel(!showRightPanel)}
                        >
                            {showRightPanel ? "→" : "←"}
                        </button>
                    )}

                    <div
                        className={`left-panel ${showLeftPanel ? "show" : ""}`}
                    >
                        <Composition />
                        <MineralsLegend />
                    </div>

                    <div className="center-panel">
                        <SvgMap setShowLeftPanel={setShowLeftPanel} />
                    </div>

                    <div
                        className={`right-panel ${
                            showRightPanel ? "show" : ""
                        }`}
                    >
                        <Filters />
                    </div>
                </div>
                <div className="waste-groups-section">
                    <WasteGroups />
                </div>
                <div className="districts-section">
                    {points.length > 0 ? (
                        <RegionsInfo />
                    ) : (
                        <p>Загрузка данных...</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MapPage;
